
const ELessonType = 
{
  Class: { Code: "Class", ID : 1},
  Individual: { Code : "Individual", ID : 0}
}


export default ELessonType; 
